import React from 'react';
import { Box, Typography, Divider } from '@mui/material';

function PrintHeader({ title, patientInfo }) {
  return (
    <Box className="print-header-component" sx={{ display: 'none' }}>
      <Box sx={{ textAlign: 'center', mb: 2 }}>
        <Typography variant="h4" fontWeight="bold">
          MSG Naturopathy Center
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Comprehensive Naturopathic Care
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Address Line 1, City, State, PIN | Phone: +91-XXXXXXXXXX
        </Typography>
      </Box>

      <Divider sx={{ my: 2, borderWidth: 2, borderColor: 'black' }} />

      <Typography variant="h5" align="center" fontWeight="bold" sx={{ my: 2 }}>
        {title}
      </Typography>

      {patientInfo && (
        <Box className="patient-info-print" sx={{
          bgcolor: 'grey.100',
          p: 2,
          mb: 2,
          border: '1px solid',
          borderColor: 'grey.400'
        }}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Patient Information
          </Typography>
          <Box className="info-row" sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
            <Box className="info-item">
              <Typography variant="body2">
                <span className="info-label">Patient Code:</span> {patientInfo.patientCode}
              </Typography>
            </Box>
            <Box className="info-item">
              <Typography variant="body2">
                <span className="info-label">Name:</span> {patientInfo.patientName}
              </Typography>
            </Box>
            <Box className="info-item">
              <Typography variant="body2">
                <span className="info-label">Room:</span> {patientInfo.roomNumber}
              </Typography>
            </Box>
            {patientInfo.admissionDate && (
              <Box className="info-item">
                <Typography variant="body2">
                  <span className="info-label">Admission Date:</span>{' '}
                  {new Date(patientInfo.admissionDate).toLocaleDateString('en-GB')}
                </Typography>
              </Box>
            )}
            {patientInfo.plannedDays > 0 && (
              <Box className="info-item">
                <Typography variant="body2">
                  <span className="info-label">Planned Days:</span> {patientInfo.plannedDays}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      )}

      <Divider sx={{ my: 2 }} />
    </Box>
  );
}

export default PrintHeader;
